import { requestWithAbort } from '@atlassian/teams-common/use-service';
export const URL_JIRA_CHECK = '/gateway/api/permissions/permitted';
export const jiraCheckRequestBody = cloudId => ({
  permissionId: 'write',
  resourceId: `ari:cloud:jira-software::site/${cloudId}`
});
export const defaultRequestAbort = cloudId => cloudId ? requestWithAbort(URL_JIRA_CHECK, {
  body: JSON.stringify(jiraCheckRequestBody(cloudId))
}) : [() => Promise.resolve(new Response()), new AbortController()];